import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DesignationListRes;
export const DesignationListTodo = createAsyncThunk('DesignationList', async (data) => {


    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'superadmin/designation',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') },

        })
        return DesignationListRes = res.data

    } catch (error) {
        return DesignationListRes = error.response.data
    }
});

const DesignationListSlice = createSlice({
    name: 'DesignationList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(DesignationListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(DesignationListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default DesignationListSlice.reducer; 